module.exports = __webpack_public_path__ + "static/media/David_Saginashvili_Resume.52cc2e45.PDF";